<div class="dialog-panel">
  <div class="dialog-content">
    <div class="icon-close" [inlineSVG]="'/assets/icons/icon-close.svg'" (click)="closeDialog()"></div>
    @if (loading) {
      <div class="spinner-container p-absolute">
        <mat-spinner class="primary" [diameter]="30"></mat-spinner>
      </div>
    }
    <form [ngClass]="{ 'v-hidden': loading }" [formGroup]="form" (submit)="onSubmit()">
      <div class="dialog-header">
        <h1 class="dialog-title">{{ 'change_password.change_password' | transloco }}</h1>
      </div>
      <div class="dialog-body">
        <p class="info mt-3">
          {{ 'change_password.change_password_description' | transloco }}
        </p>

        <div class="row">
          <div class="col-12">
            <div class="form-field-container">
              <div class="form-field-label" [ngClass]="{ required: isFormControlRequired(form.get('password')) }">
                {{ 'form.field.current_password' | transloco }}
              </div>
              <div class="input-password">
                <input
                  class="form-control"
                  [type]="hideCurrentPwd ? 'password' : 'text'"
                  formControlName="password"
                  autocomplete="current-password"
                  [class.form-control-error]="form.get('password').invalid && form.get('password').touched"
                />
                <span
                  class="form-field-eye-icon"
                  [ngClass]="{ active: !hideCurrentPwd }"
                  [inlineSVG]="hideCurrentPwd ? '/assets/icons/icon-eye-closed.svg' : '/assets/icons/icon-eye.svg'"
                  (click)="hideCurrentPwd = !hideCurrentPwd; $event.preventDefault()"
                ></span>
              </div>
              @if (form.get('password').invalid && form.get('password').touched) {
                <div class="error-message">
                  {{ 'form.error.required' | transloco }}
                </div>
              }
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-field-container">
              <div class="form-field-label" [ngClass]="{ required: isFormControlRequired(form.get('password_new')) }">
                {{ 'form.field.new_password' | transloco }}
              </div>
              <div class="input-password">
                <input
                  class="form-control"
                  [type]="hideNewPwd ? 'password' : 'text'"
                  formControlName="password_new"
                  autocomplete="new-password"
                  [class.form-control-error]="form.get('password_new').invalid && form.get('password_new').touched"
                />
                <span
                  class="form-field-eye-icon"
                  [ngClass]="{ active: !hideNewPwd }"
                  [inlineSVG]="hideNewPwd ? '/assets/icons/icon-eye-closed.svg' : '/assets/icons/icon-eye.svg'"
                  (click)="hideNewPwd = !hideNewPwd; $event.preventDefault()"
                ></span>
              </div>
              @if (form.get('password_new').invalid && form.get('password_new').touched) {
                <div class="error-message">
                  {{ 'form.errors.password_pattern' | transloco }}
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-bottom">
        <button type="submit" class="btn btn-primary d-block w-100" [disabled]="form.invalid">
          {{ 'change_password.change_password' | transloco }}
        </button>
      </div>
    </form>
  </div>
</div>
